(() => {
  if (customElements.get('scary-deals-price')) return;
  let clockPromise;
  let clock;
  async function serverNow() {
    if (clock && performance.now() - clock.checked < 300000) {
      return clock.time + performance.now() - clock.checked;
    }
    if (!clockPromise) {
      clockPromise = fetch(window.location.href, {
        method: 'HEAD', cache: 'no-store', credentials: 'same-origin',
        signal: AbortSignal.timeout(5000)
      }).then(response => {
        const time = Date.parse(response.headers.get('date'));
        if (!response.ok || !Number.isFinite(time)) throw new Error('Clock unavailable');
        clock = { time, checked: performance.now() };
        return time;
      }).finally(() => { clockPromise = undefined; });
    }
    return clockPromise;
  }
  class ScaryDealsPrice extends HTMLElement {
    connectedCallback() {
      this.regular = this.querySelector('[data-scary-regular]');
      this.offer = this.querySelector('[data-scary-offer]');
      this.start = Date.parse(this.dataset.start);
      this.end = Date.parse(this.dataset.end);
      if (!this.regular || !this.offer) return;
      this.onVisibility = () => { if (!document.hidden) this.refresh(); };
      document.addEventListener('visibilitychange', this.onVisibility);
      this.refresh();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('visibilitychange', this.onVisibility);
    }
    async refresh() {
      clearTimeout(this.timer);
      let now;
      try {
        now = await serverNow();
        this.dataset.clock = 'verified';
      } catch {
        this.dataset.clock = 'unavailable';
      }
      if (!this.isConnected) return;
      const active = Number.isFinite(now) && now >= this.start && now < this.end;
      this.offer.hidden = !active;
      this.regular.hidden = active;
      this.dataset.state = active ? 'active' : 'regular';
      const boundary = now < this.start ? this.start : this.end;
      const delay = Number.isFinite(now) && boundary > now ? Math.min(60000, boundary - now + 100) : 60000;
      this.timer = setTimeout(() => this.refresh(), delay);
    }
  }
  customElements.define('scary-deals-price', ScaryDealsPrice);
})();
